import React, { FC, useState } from 'react';
import { Box, Unstable_Grid2 as Grid } from '@mui/material';

import { BillingPortalPlanType, BillingPortalRoute, useGetBillingUrlQuery } from 'api';
import { useCurrentUser, useNotify, useProtectedClient } from 'hooks';
import { getAppImage, isFreeWorkspace, isTeamsWorkspace, isTrialingTeamsWorkspace } from 'helpers';
import * as paths from 'paths';

import { Enterprise, Teams, TeamsTrial } from '../components/Billing';

const Upgrade: FC = () => {
  const notify = useNotify();
  const currentUser = useCurrentUser();
  const client = useProtectedClient();
  const [fetchBillingLink, setFetchBillingLink] = useState(false);

  const { location } = window;

  const isTrialingTeams = isTrialingTeamsWorkspace(client);
  const isFree = isFreeWorkspace(client);
  const isTeams = isTeamsWorkspace(client);
  const returnUrl = `${location.protocol}//${location.host}${paths.adminAnalytics}`;

  const variables = {
    client_id: currentUser.client_id,
    user_id: currentUser.id,
    return_url: returnUrl,
    plan_type: BillingPortalPlanType.Teams,
    route: BillingPortalRoute.Plan,
  };

  const { isLoading } = useGetBillingUrlQuery(variables, {
    enabled: !!fetchBillingLink,
    onError: () => {
      notify.queryError();
      setFetchBillingLink(false);
    },
    onSuccess: ({ getBillingCustomerPortalEphemeralUrl }) => {
      window.location.href = getBillingCustomerPortalEphemeralUrl.url;
    },
  });

  function handleUpgrade() {
    setFetchBillingLink(true);
  }

  function renderLeft() {
    return (
      <Box textAlign="center">
        <img height={350} {...getAppImage('illustrations/bubble.png', 350)} />
      </Box>
    );
  }

  return (
    <Box paddingBottom={4} paddingTop={4}>
      <Grid container alignItems="center" justifyContent="center">
        <Grid xs={6}>{renderLeft()}</Grid>
        <Grid xs={6}>
          {isFree && <Teams isLoading={isLoading} onClick={handleUpgrade} />}
          {isTrialingTeams && <TeamsTrial isLoading={isLoading} onClick={handleUpgrade} />}\
          {isTeams && <Enterprise />}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Upgrade;
